import { combineReducers } from "@reduxjs/toolkit";
import toastSlice from './toastSlice';
import authReducer from "./authReducer";
import cartSlice from './cartSlice';
import paymentSlice from "./paymentSlice";
import modalSlice from "./modalSlice";

const rootReducer = combineReducers({
	toast: toastSlice,
	auth: authReducer,
	cart: cartSlice,
	payment: paymentSlice,
	userMessageModal: modalSlice
});

export default rootReducer;
